import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

import { CloseButtonComponent } from '../close-button/close-button.component';
import { IconName } from '../icons/auto-generated/icon-name';
import { IconComponent } from '../icons/icon.component';

const BASE_CSS_CLASSES = ['toast', 'show'];

@Component({
  imports: [IconComponent, CloseButtonComponent],
  selector: 'mop-toast',
  template: `
    <div
      [class]="cssClasses()"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="toast-header">
        <mop-icon [name]="iconName()" outlined="true"></mop-icon>
        <div>
          @if (title()) {
            <h5>{{ title() }}</h5>
          }
          <ng-content></ng-content>
        </div>
        @if (closable()) {
          <mop-close-button (close)="close.emit()"></mop-close-button>
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  type = input<'danger' | 'primary' | 'secondary' | 'success'>('primary');
  title = input('');
  closable = input(true, { transform: booleanAttribute });

  close = output();

  cssClasses = computed(() => {
    switch (this.type()) {
      case 'danger':
        return [...BASE_CSS_CLASSES, 'toast-danger'];
      case 'secondary':
        return [...BASE_CSS_CLASSES, 'toast-secondary'];
      case 'success':
        return [...BASE_CSS_CLASSES, 'toast-success'];
      default:
        return [...BASE_CSS_CLASSES, 'toast-primary'];
    }
  });

  iconName = computed<IconName>(() => {
    switch (this.type()) {
      case 'danger':
        return 'alert';
      case 'secondary':
        return 'info';
      case 'success':
        return 'check-circle';
      default:
        return 'info';
    }
  });
}
